.container {
  flex-direction: column;
  padding: 20px;
  border-radius: 10px;
  border: 1px solid #d2d2d2;
}

hr {
  border: 0;
  border-top: 1px solid #d2d2d2;
}

.oneShot {
  background-color: #deecff;
  color: #384d68;
  border-radius: 10px;
  padding: 2px 10px;
  font-size: 12px;
  font-weight: 600;
}

.critical {
  background-color: #ffeaea;
  color: #573333;
  border-radius: 10px;
  padding: 2px 10px;
  font-size: 12px;
  font-weight: 600;
}

.header {
  margin-bottom: 40px;
}

.title {
  font-size: 25px;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 8px;
}

:global(.clb-table-container) {
  width: 100%;
}

.subtitle {
  font-size: 16px;
  color: #6c757d;
  margin: 0;
}

.content {
  display: flex;
  flex-direction: column;
  gap: 40px;
}

.cardsRow {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
}
@media (max-width: 1024px) {
  .cardsRow {
    grid-template-columns: 1fr;
  }
}

.card {
  border: 2px solid;
  border-radius: 12px;
  overflow: hidden;
  background: white;
}

.cardHeader {
  padding: 16px 20px;
}
.cardHeader h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
}

.cardContent {
  padding: 20px;
}

.cardDescription {
  margin-top: 12px;
  font-size: 14px;
  color: #6c757d;
  line-height: 1.4;
}

.previewSection {
  background: #f8f9fa;
  padding: 24px;
  border-radius: 8px;
}
.previewSection h3 {
  margin: 0 0 20px 0;
  font-size: 20px;
  color: #2c3e50;
}

.rangePreview {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.rangeBar {
  display: flex;
  height: 60px;
  border-radius: 8px;
  overflow: hidden;
}

.rangeSegment {
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: 600;
  font-size: 14px;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
  min-width: 120px;
}
.rangeSegment span {
  padding: 4px 8px;
  background: rgba(0, 0, 0, 0.1);
  border-radius: 4px;
}

.actions {
  display: flex;
  flex-direction: column;
  align-items: end;
  gap: 12px;
}

.errorText {
  color: #dc3545;
  font-size: 14px;
  margin: 0;
  text-align: center;
}

:global(.clb-loading) {
  z-index: 1000;
}

:global(.rs-input-number) {
  width: 100% !important;
}
:global(.rs-input-number) input {
  text-align: center;
  font-size: 16px;
  font-weight: 500;
}
:global(.rs-input-number) .rs-input-number-btn-group-vertical {
  display: flex !important;
}
:global(.rs-input-number) .rs-input-number-btn-group-vertical .rs-input-number-btn {
  display: block !important;
  opacity: 1 !important;
}

.numberInput :global(.rs-input-number) .rs-input-number-btn {
  border: 1px solid #d1d5db !important;
  background: #f8f9fa !important;
}
.numberInput :global(.rs-input-number) .rs-input-number-btn:hover {
  background: #e9ecef !important;
  border-color: #0066cc !important;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */